module.exports = __webpack_public_path__ + "static/functions-screen-3-134ff9787297ba631c2d6b1f719ebe63.png";